<template>
  <div class="flex min-h-screen bg-slate-50">
    <!-- 사이드바 -->
    <SideBar />

    <!-- 메인 컨텐츠 -->
    <main class="flex-1 overflow-auto">
      <slot />
    </main>
  </div>
</template>

<script>
import SideBar from './SideBar.vue'

export default {
  name: 'AdminLayout',
  components: {
    SideBar
  }
}
</script>
